import { render, staticRenderFns } from "./CourierStatusUpdated.vue?vue&type=template&id=2ba855aa"
import script from "./CourierStatusUpdated.vue?vue&type=script&lang=ts"
export * from "./CourierStatusUpdated.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports